<script>
  import Card from "./Card.svelte";
  import Content from "../content/root.js";

  console.log(Content);
</script>

<style>
  .App {
    margin: 30px 5%;
    background-color: var(--colour-background);
  }

  h1 {
    font-size: 32px;
    text-align: center;
    font-family: var(--font-heading);
    font-weight: normal;
    font-style: italic;
    margin-top: 0;
    margin-bottom: 30px;
  }

  .basmala {
    text-align: center;
    margin: 15px;
    margin-top: -10px;
    font-size: 20px;
  }

  .content {
    display: grid;
    grid-column: auto;
    grid-column-gap: 15px;
    grid-row-gap: 30px;
  }

  @media (min-width: 800px) {
    .content {
      grid-template-columns: 1fr 1fr;
    }
  }

  @media (min-width: 1200px) {
    .content {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }

  .references {
    font-size: 12px;
    text-align: center;
    margin: 30px 0;
    color: var(--colour-primary-l);
  }

  a {
    text-decoration: none;
    font-weight: bold;
    color: var(--colour-primary-l);
  }

  .highlight {
    background-color: var(--colour-secondary);
    padding: 2px 5px;
  }
</style>

<div class="App">
  <h1>Rak'ah</h1>
  <p class="basmala">﷽‎</p>

  <div class="content">
    {#each Content as salah}
      <div class="grid-sizing-wrapper">
        <Card data={salah} />
      </div>
    {/each}
  </div>
  <p class="references">
    Information from
    <a href="https://moonsighting.com/">Moonsighting</a>
    ,
    <a
      href="http://www.islamicacademy.org/html/Learn_Now/English/Salah_Amount.htm">
      Islamic Academy
    </a>
    , and
    <a href="https://www.radioislam.org.za/">Radio Islam</a>
    . Rak'ah infomation displayed as applicable to Hanafi
  </p>
</div>
